<template>
  <div class="page-content">
    <!-- Background -->
    <v-img
      src="@/assets/images/Start BG Image.png"
      style="height: 100vh; width: 100%"
    />

    <!-- Language -->
    <div
      :style="main"
      style="column-gap: 15px; position: absolute; top: 30px; right: 30px"
      class="d-flex flex-row justify-end align-center"
    >
      <div class="white--text font-weight-light" style="font-size: 20px">
        {{ this.language.code }}
      </div>
      <button @click="openDialog">
        <img
          src="@/assets/icons/Drop Down Button.svg"
          style="height: 18px; width: auto"
        />
      </button>
    </div>

    <!-- Title -->
    <div
      class="d-flex flex-row justify-center align-center"
      style="column-gap: 10px; top: 25%; position: absolute; width: 100%"
    >
      <div class="d-flex flex-column align-center">
        <img
          v-if="language && language.code == 'en'"
          src="@/assets/images/Title EN.png"
          alt=""
          :style="
            !$vuetify.breakpoint.xs ? 'max-width: 500px' : 'max-width: 300px'
          "
        />
        <img
          v-else
          src="@/assets/images/Title GR.png"
          alt=""
          :style="
            !$vuetify.breakpoint.xs ? 'max-width: 500px' : 'max-width: 300px'
          "
        />
      </div>
    </div>

    <!-- Start Button -->
    <div
      class="d-flex flex-column justify-center align-center"
      style="position: absolute; width: 100%"
      :style="$vuetify.breakpoint.xs ? 'bottom: 25%' : 'bottom: 40%;'"
    >
      <button
        style="
          background-color: var(--v-text_background-base);
          border-radius: 8px;
        "
        class="py-1 px-16"
        @click="start"
      >
        <div class="background--text font-weight-light" style="font-size: 25px">
          {{ $t("start.start") }}
        </div>
      </button>
    </div>

    <!-- Info -->
    <div
      class="d-flex flex-column justify-center align-center"
      style="bottom: 5%; position: absolute; width: 100%"
    >
      <img
        v-if="language.code == 'el'"
        src="@/assets/images/logo-white.png"
        alt=""
        style="max-width: 350px"
      />
      <img
        v-else
        src="@/assets/images/logo-white-en.png"
        alt=""
        style="max-width: 350px"
      />
    </div>

    <v-dialog v-model="dialog" max-width="300px">
      <LanguageDialog @close="closeDialog"></LanguageDialog>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LanguageDialog from "../../components/Dialogs/LanguageDialog.vue";

export default {
  data() {
    return {
      dialog: false,
    };
  },

  components: {
    LanguageDialog,
  },

  computed: {
    ...mapState({
      insets: (state) => state.base.insets,

      language: (state) => state.base.mobileLang,
    }),

    main() {
      return `top: calc(${
        this.insets?.top ? this.insets?.top + "px" : "0px"
      } + 30px)`;
    },
  },

  methods: {
    start() {
      this.$router.push("/home");
    },
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style>
.page-content {
  position: absolute;
  /* top: -56px; */
  bottom: 0;
  width: 100%;
  z-index: 0;
  overflow-y: auto;
}
</style>
